import { FormControlLabel, Checkbox } from '@mui/material';

import { DrillDifficultyTags, DrillPlayersNeededTags } from '@labradorsports/constants';
import { useSite } from '@labradorsports/utils';

interface Props {
    value: string[];
    onChange: (newValue: string[]) => void;
    showDrillTags?: boolean;
}

const PlayTags: FC<Props> = ({ value, onChange, showDrillTags = false }) => {
    const { Config } = useSite();

    const tagChange = (evt: any) => {
        const tag = evt.target.value;

        if (evt.target.checked) {
            onChange(value.concat([tag]));
        } else {
            onChange(value.filter((t: string) => t !== tag));
        }
    };

    const tagCheckbox = (tag: string) => (
        <div className="d-inline-block tag-container" key={tag}>
            <FormControlLabel
                label={tag}
                className="tag-label"
                control={
                    <Checkbox className="tag-checkbox" value={tag} checked={value.includes(tag)} onChange={tagChange} />
                }
            />
        </div>
    );

    return (
        <div className="play-tags">
            <div className="text-start">{Config.PlayTags.map(tagCheckbox)}</div>
            {showDrillTags ? (
                <>
                    <span className="header-label">Difficulty:</span>
                    <div className="text-start">{DrillDifficultyTags.map(tagCheckbox)}</div>
                    <span className="header-label">Skills Developed:</span>
                    <div className="text-start">{Config.DrillSkillTags.map(tagCheckbox)}</div>
                    <span className="header-label">Players Needed:</span>
                    <div className="text-start">{DrillPlayersNeededTags.map(tagCheckbox)}</div>
                </>
            ) : null}
        </div>
    );
};

export default PlayTags;
